export default __webpack_public_path__ + "static/media/repeat.4643b40a.svg";